import { Protocol } from "pmtiles";

// MapLibre's addProtocol surface (typed locally so unit tests don't import the
// browser bundle / WebGL).
interface ProtocolHost {
  addProtocol(scheme: string, handler: (...a: unknown[]) => unknown): void;
}

let registered = false;
let protocol: Protocol | undefined;

/** Register the pmtiles:// protocol on a maplibre-gl module handle. Idempotent. */
export function registerPmtilesProtocol(maplibre: ProtocolHost): Protocol {
  if (!protocol) protocol = new Protocol();
  if (!registered) {
    maplibre.addProtocol("pmtiles", protocol.tile as unknown as (...a: unknown[]) => unknown);
    registered = true;
  }
  return protocol;
}
